<template>
  <DropdownData
    :modelValue="modelValue"
    @update:modelValue="$emit('update:modelValue', $event)"
    :serviceFunction="fetchData"
    placeholder="Seleccione una Sucursal..."
    :disabled="disabled"
  />
</template>

<script>
import DropdownData from './DropdownData.vue';
// Asegúrate de que la ruta a tu servicio sea la correcta
import SucursalService from '@/service/SucursalService'; 

export default {
  name: 'DropdownSucursal',
  components: {
    DropdownData
  },
  props: {
    // El ID que viajará mediante el v-model
    modelValue: {
      type: [String, Number],
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.sucursalService = new SucursalService();
  },
  methods: {
    fetchData() {
      // Retornamos la promesa al componente base (DropdownData)
      return this.sucursalService.getSucursalCombo();
    }
  }
}
</script>
